import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { get, post } from "../../../actions/general";


import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";
import { IStateTree } from "../../../store/interfaces";
import { IUser } from "../../../store/user/models";

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser,
});

export default {
    component: connect(mapStateToProps, { get, post })(injectIntl(loadableComponent)),
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({ title: "Musicators", allMessage, lang });
    },
};
